import chroma from 'chroma-js';
export const colors = [
    {
        name: 'Mahogany',
        hex: '#CD4A4A',
    },
    {
        name: 'Fuzzy Wuzzy Brown',
        hex: '#CC6666',
    },
    {
        name: 'Chestnut',
        hex: '#BC5D58',
    },
    {
        name: 'Red Orange',
        hex: '#FF5349',
    },
    {
        name: 'Sunset Orange',
        hex: '#FD5E53',
    },
    {
        name: 'Bittersweet',
        hex: '#FD7C6E',
    },
    {
        name: 'Melon',
        hex: '#FDBCB4',
    },
    {
        name: 'Outrageous Orange',
        hex: '#FF6E4A',
    },
    {
        name: 'Vivid Tangerine',
        hex: '#FFA089',
    },
    {
        name: 'Burnt Sienna',
        hex: '#EA7E5D',
    },
    {
        name: 'Brown',
        hex: '#B4674D',
    },
    {
        name: 'Sepia',
        hex: '#A5694F',
    },
    {
        name: 'Orange',
        hex: '#FF7538',
    },
    {
        name: 'Burnt Orange',
        hex: '#FF7F49',
    },
    {
        name: 'Copper',
        hex: '#DD9475',
    },
    {
        name: 'Mango Tango',
        hex: '#FF8243',
    },
    {
        name: 'Atomic Tangerine',
        hex: '#FFA474',
    },
    {
        name: 'Beaver',
        hex: '#9F8170',
    },
    {
        name: 'Antique Brass',
        hex: '#CD9575',
    },
    {
        name: 'Desert Sand',
        hex: '#EFCDB8',
    },
    {
        name: 'Raw Sienna',
        hex: '#D68A59',
    },
    {
        name: 'Tumbleweed',
        hex: '#DEAA88',
    },
    {
        name: 'Tan',
        hex: '#FAA76C',
    },
    {
        name: 'Peach',
        hex: '#FFCFAB',
    },
    {
        name: 'Macaroni and Cheese',
        hex: '#FFBD88',
    },
    {
        name: 'Apricot',
        hex: '#FDD9B5',
    },
    {
        name: 'Neon Carrot',
        hex: '#FFA343',
    },
    {
        name: 'Almond',
        hex: '#EFDBC5',
    },
    {
        name: 'Yellow Orange',
        hex: '#FFB653',
    },
    {
        name: 'Gold',
        hex: '#E7C697',
    },
    {
        name: 'Shadow',
        hex: '#8A795D',
    },
    {
        name: 'Banana Mania',
        hex: '#FAE7B5',
    },
    {
        name: 'Sunglow',
        hex: '#FFCF48',
    },
    {
        name: 'Goldenrod',
        hex: '#FCD975',
    },
    {
        name: 'Dandelion',
        hex: '#FDDB6D',
    },
    {
        name: 'Yellow',
        hex: '#FCE883',
    },
    {
        name: 'Green Yellow',
        hex: '#F0E891',
    },
    {
        name: 'Spring Green',
        hex: '#ECEABE',
    },
    {
        name: 'Olive Green',
        hex: '#BAB86C',
    },
    {
        name: 'Laser Lemon',
        hex: '#FDFC74',
    },
    {
        name: 'Unmellow Yellow',
        hex: '#FDFC74',
    },
    {
        name: 'Canary',
        hex: '#FFFF99',
    },
    {
        name: 'Yellow Green',
        hex: '#C5E384',
    },
    {
        name: 'Inch Worm',
        hex: '#B2EC5D',
    },
    {
        name: 'Asparagus',
        hex: '#87A96B',
    },
    {
        name: 'Granny Smith Apple',
        hex: '#A8E4A0',
    },
    {
        name: 'Electric Lime',
        hex: '#1DF914',
    },
    {
        name: 'Screamin Green',
        hex: '#76FF7A',
    },
    {
        name: 'Fern',
        hex: '#71BC78',
    },
    {
        name: 'Forest Green',
        hex: '#6DAE81',
    },
    {
        name: 'Sea Green',
        hex: '#9FE2BF',
    },
    {
        name: 'Green',
        hex: '#1CAC78',
    },
    {
        name: 'Mountain Meadow',
        hex: '#30BA8F',
    },
    {
        name: 'Shamrock',
        hex: '#45CEA2',
    },
    {
        name: 'Jungle Green',
        hex: '#3BB08F',
    },
    {
        name: 'Caribbean Green',
        hex: '#1CD3A2',
    },
    {
        name: 'Tropical Rain Forest',
        hex: '#17806D',
    },
    {
        name: 'Pine Green',
        hex: '#158078',
    },
    {
        name: 'Robin Egg Blue',
        hex: '#1FCECB',
    },
    {
        name: 'Aquamarine',
        hex: '#78DBE2',
    },
    {
        name: 'Turquoise Blue',
        hex: '#77DDE7',
    },
    {
        name: 'Sky Blue',
        hex: '#80DAEB',
    },
    {
        name: 'Outer Space',
        hex: '#414A4C',
    },
    {
        name: 'Blue Green',
        hex: '#199EBD',
    },
    {
        name: 'Pacific Blue',
        hex: '#1CA9C9',
    },
    {
        name: 'Cerulean',
        hex: '#1DACD6',
    },
    {
        name: 'Cornflower',
        hex: '#9ACEEB',
    },
    {
        name: 'Midnight Blue',
        hex: '#1A4876',
    },
    {
        name: 'Navy Blue',
        hex: '#1974D2',
    },
    {
        name: 'Denim',
        hex: '#2B6CC4',
    },
    {
        name: 'Blue',
        hex: '#1F75FE',
    },
    {
        name: 'Periwinkle',
        hex: '#C5D0E6',
    },
    {
        name: 'Cadet Blue',
        hex: '#B0B7C6',
    },
    {
        name: 'Indigo',
        hex: '#5D76CB',
    },
    {
        name: 'Wild Blue Yonder',
        hex: '#A2ADD0',
    },
    {
        name: 'Manatee',
        hex: '#979AAA',
    },
    {
        name: 'Blue Bell',
        hex: '#ADADD6',
    },
    {
        name: 'Blue Violet',
        hex: '#7366BD',
    },
    {
        name: 'Purple Heart',
        hex: '#7442C8',
    },
    {
        name: 'Royal Purple',
        hex: '#7851A9',
    },
    {
        name: 'Purple Mountains’ Majesty',
        hex: '#9D81BA',
    },
    {
        name: 'Violet (Purple)',
        hex: '#926EAE',
    },
    {
        name: 'Wisteria',
        hex: '#CDA4DE',
    },
    {
        name: 'Vivid Violet',
        hex: '#8F509D',
    },
    {
        name: 'Fuchsia',
        hex: '#C364C5',
    },
    {
        name: 'Shocking Pink',
        hex: '#FB7EFD',
    },
    {
        name: 'Pink Flamingo',
        hex: '#FC74FD',
    },
    {
        name: 'Plum',
        hex: '#8E4585',
    },
    {
        name: 'Hot Magenta',
        hex: '#FF1DCE',
    },
    {
        name: 'Purple Pizzazz',
        hex: '#FF1DCE',
    },
    {
        name: 'Razzle Dazzle Rose',
        hex: '#FF48D0',
    },
    {
        name: 'Orchid',
        hex: '#E6A8D7',
    },
    {
        name: 'Red Violet',
        hex: '#C0448F',
    },
    {
        name: 'Eggplant',
        hex: '#6E5160',
    },
    {
        name: 'Cerise',
        hex: '#DD4492',
    },
    {
        name: 'Wild Strawberry',
        hex: '#FF43A4',
    },
    {
        name: 'Magenta',
        hex: '#F664AF',
    },
    {
        name: 'Lavender',
        hex: '#FCB4D5',
    },
    {
        name: 'Cotton Candy',
        hex: '#FFBCD9',
    },
    {
        name: 'Violet Red',
        hex: '#F75394',
    },
    {
        name: 'Carnation Pink',
        hex: '#FFAACC',
    },
    {
        name: 'Razzmatazz',
        hex: '#E3256B',
    },
    {
        name: 'Piggy Pink',
        hex: '#FDD7E4',
    },
    {
        name: 'Jazzberry Jam',
        hex: '#CA3767',
    },
    {
        name: 'Blush',
        hex: '#DE5D83',
    },
    {
        name: 'Tickle Me Pink',
        hex: '#FC89AC',
    },
    {
        name: 'Pink Sherbet',
        hex: '#F780A1',
    },
    {
        name: 'Maroon',
        hex: '#C8385A',
    },
    {
        name: 'Red',
        hex: '#EE204D',
    },
    {
        name: 'Radical Red',
        hex: '#FF496C',
    },
    {
        name: 'Mauvelous',
        hex: '#EF98AA',
    },
    {
        name: 'Wild Watermelon',
        hex: '#FC6C85',
    },
    {
        name: 'Scarlet',
        hex: '#FC2847',
    },
    {
        name: 'Salmon',
        hex: '#FF9BAA',
    },
    {
        name: 'Brick Red',
        hex: '#CB4154',
    },
    {
        name: 'White',
        hex: '#EDEDED',
    },
    {
        name: 'Timberwolf',
        hex: '#DBD7D2',
    },
    {
        name: 'Silver',
        hex: '#CDC5C2',
    },
    {
        name: 'Gray',
        hex: '#95918C',
    },
    {
        name: 'Black',
        hex: '#232323',
    },
];
export function findNearestColor(color) {
    return colors
        .map((pantone) => {
        const distance = chroma.distance(color, chroma(pantone.hex));
        return {
            hex: pantone.hex,
            name: pantone.name,
            distance,
        };
    })
        .sort((a, b) => a.distance - b.distance)[0];
}
